import React from 'react';
import { DEFAULT_AB_SPLIT_RATIO } from '../../../constants';
import type { AbSplitStep } from '../../../types';
import StepCardFrame from './StepCardFrame';
import * as styles from './journey.module.css';
const AbSplitCard: React.FC<{ step: AbSplitStep }> = ({ step }) => {
    const ratio = step.ratio ?? DEFAULT_AB_SPLIT_RATIO;
    return (
        <StepCardFrame id={step.id} title="A/B split" kind="split">
            <div className={styles.ratios}>
                <span>
                    A <strong>{ratio}%</strong>
                </span>
                <span>
                    B <strong>{100 - ratio}%</strong>
                </span>
            </div>
        </StepCardFrame>
    );
};
export default AbSplitCard;
